import { render, staticRenderFns } from "./Relationship.vue?vue&type=template&id=5aad089e&scoped=true"
import script from "./Relationship.vue?vue&type=script&lang=js"
export * from "./Relationship.vue?vue&type=script&lang=js"
import style0 from "./Relationship.vue?vue&type=style&index=0&id=5aad089e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad089e",
  null
  
)

export default component.exports